real.scroller = (($, real) => {
    return {
        init: () => {
            // (PAGE_BECAME_VISIBLE constant is not accessible yet)
            real.dom.$body.on('page-became-visible', real.scroller.check);
        },
        check: () => {
            let hash = window.location.hash;

            if (!hash) {
                // No hash present
                return;
            }

            // Remove second hash character if it is _ (our hack to prevent default scrolling)
            if (hash[1] === '_') {
                hash = hash.substring(0, 1) + hash.substring(2);
            }

            // Delete hash straight away
            real.history.replace(window.location.toString().split('#')[0]);

            let id;
            let fbId;

            // Check if the hash contains a fallback ID to scroll to. This is used
            // for comments, which might be hidden, so then we scroll to the fallback
            // (which is the widget).
            const fbPos = hash.indexOf('+');
            if (fbPos === -1) {
                id = hash;
                fbId = null;
            } else {
                id = hash.substring(0, fbPos);
                fbId = '#' + hash.substring(fbPos+1);
            }

            // Just a crude way to wait for the content to load
            setTimeout(() => real.scroller.to(id, fbId), 750);
        },
        to: (id, fbId) => {
            $('#real-scroller-cover').remove();
            let $ele = $(id);
            if ($ele.length === 0 && fbId) {
                // Try fallback
                $ele = $(fbId);
            }

            if ($ele.length === 0 || $ele.is(':hidden') || $ele.hasClass('d-none')) {
                // Do not try to scroll when element does not exist or is invisible
                return;
            }

            scrollTo({
                top: $ele.offset().top-80,
                left: 0,
                behavior: "instant",
            });
            setTimeout(() => $ele.fadeOut(200, () => $ele.fadeIn(200)), 350);
        },
    };
})(jQuery, real);

real.scroller.init();
